var React = require('react');

function CartIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"currentColor","strokeLinecap":"round","strokeWidth":"2","transform":"translate(2 2)"},[React.createElement("path",{"d":"m15.991342.00865802-15.98268398 15.98268398","key":0}),React.createElement("path",{"d":"m15.991342 15.991342-15.98268398-15.98268398","key":1})]));
}

CartIcon.defaultProps = {"height":"20","viewBox":"0 0 20 20","width":"20"};

module.exports = CartIcon;

CartIcon.default = CartIcon;
